import { render } from "./ActivityScorm.vue?vue&type=template&id=cd0af37e&scoped=true"
import script from "./ActivityScorm.vue?vue&type=script&lang=js"
export * from "./ActivityScorm.vue?vue&type=script&lang=js"

import "./ActivityScorm.vue?vue&type=style&index=0&id=cd0af37e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0af37e"]])

export default __exports__